import { GET_TREATMENT_PLANS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response {
    success: boolean;
    treatmentPlans: TreatmentPlan[];
    error?: string;
}

export interface TreatmentPlan {
    _id: string;
    docid: string;
    patientid: string;
    created_at: string;
    updated_at: string;
    name: string;
    services: Service[];
    plan_id: string;
    type: TREATMENT_PLAN_TYPE;
    discount: number;
    aid?: string;
    pxid?: string;
}

export enum TREATMENT_PLAN_TYPE {
    ESTIMATE = 'estimate',
    ONGOING_PLAN = 'ongoing-plan',
    COMPLETED_PLAN = 'completed-plan',
}

export interface Service {
    id: string;
    name: string;
    teeth_ids?: string[];
    surfaces?: Surface[];
    qty: number;
    mrp: number;
    discount: number;
    amount: number;
    remarks?: string;
}

export interface Surface {
    id: string;
    name: string;
}

export default (patientId: string, type?: TREATMENT_PLAN_TYPE): Promise<Response> => {
    return fetchWithRefresh(GET_TREATMENT_PLANS(patientId, type)).then((res) => res.json());
};
